<!-- <div class="d-flex flex-column w-100">
    @for(perm of $permissions(); track perm.key) {
        <div class="d-flex py-1">
            <div class="d-flex flex-column justify-content-center me-3">
                <strong>{{ perm.label }}</strong>
                @if (perm.description) {
                    <span class="text-muted">{{perm.description}}</span>
                }
            </div>
            <div
                class="ms-auto me-1 d-flex flex-column justify-content-center align-items-center text-center"
                style="font-size: 0.75em; line-height: 1em; min-width: 100px;"
            >
                @if(perm.affectingRoles.length) {
                    <span class="">{{'PERMISSIONS.LABEL_AFFECTING_ROLES' | translate}}</span>
                    <span class="text-muted">{{perm.affectingRoles.join(', ')}}</span>
                }
            </div>
            <div class="d-flex justify-content-center align-items-center">
                <dx-lookup
                    [(value)]="perm.active"
                    [width]="160"
                    [dataSource]="switchDataSource"
                    valueExpr="value"
                    displayExpr="text"
                    [disabled]="!canChangePermission(perm.key)"
                ></dx-lookup>
            </div>
        </div>
    }
</div> -->

<div class="d-flex h-100 w-100">
    <dx-tabs [dataSource]="tabs"
        [selectedIndex]="$selectedTabIndex()"
        (selectedIndexChange)="$selectedTabIndex.set($event)"
        [showNavButtons]="true"
        orientation="vertical"
        height="100%"
        class="h-100 flex-grow-0 p-0 m-0 border-end" />

    <div class="flex-grow-1 h-100 px-2 py-1" style="max-width: calc(100% - 120px);">
        <app-scroll-view>
            <dx-multi-view [selectedIndex]="$selectedTabIndex()">
                @for(group of $permissionsGrouped(); track group.id){
                    <dxi-multi-view-item>
                        <div *dxTemplate class="dx-fieldset mt-0 pt-0 h-100 w-100 m-0 p-0">
                            <div class="dx-fieldset-header mb-3">
                                <strong>{{ group.text }}</strong>
                            </div>

                            @for(perm of group.permissions; track perm.key){
                                <div class="dx-field mb-2">
                                    <div class="dx-field-label d-flex flex-column" style="width: calc(100% - 150px);">
                                        <p class="m-0 fw-bold">{{ perm.label }}</p>
                                        @if (perm.description) {
                                            <p class="m-0 text-muted text-truncate">{{perm.description}}</p>
                                        }
                                    </div>
                                    <div class="dx-field-value" style="width: 150px">
                                        <dx-lookup
                                            [(value)]="perm.active"
                                            width="100%"
                                            [dataSource]="switchDataSource"
                                            valueExpr="value"
                                            displayExpr="text"
                                            [disabled]="!canChangePermission(perm.key)"
                                        ></dx-lookup>
                                    </div>
                                </div>
                            }
                        </div>
                    </dxi-multi-view-item>
                }

            </dx-multi-view>
        </app-scroll-view>
    </div>



</div>
